/**
 * KAYIP-2/6: kart içi mini harita — CANLI HARİTA DEĞİL.
 *
 * Listede her karta MapLibre açmak sayfayı kasar; bunun yerine tek karo
 * görüntüsü (CARTO raster — atıf uygulama footer'ında) + CSS ile çizilen
 * arama dairesi. Kayıp noktası karonun içinde piksel hesabıyla konumlanır.
 * Sightings kartları ve anasayfa kayıp şeridi aynı bileşeni kullanır.
 */
export default function KayipMiniHarita({ lat, lng, radiusM, height = 80, className = "mt-2 rounded-xl border border-sky-100" }) {
  const z = 15;
  const n = 2 ** z;
  const xF = ((lng + 180) / 360) * n;
  const latR = (lat * Math.PI) / 180;
  const yF = ((1 - Math.log(Math.tan(latR) + 1 / Math.cos(latR)) / Math.PI) / 2) * n;
  const xT = Math.floor(xF);
  const yT = Math.floor(yF);
  const px = (xF - xT) * 256;
  const py = (yF - yT) * 256;
  const mPerPx = (156543.03392 * Math.cos(latR)) / n;
  const rPx = Math.max(8, Math.min(60, (radiusM || 300) / mPerPx));
  const H = height;
  return (
    <div
      className={`relative overflow-hidden ${className}`}
      style={{ height: H }}
      data-testid="lost-mini-map"
      aria-hidden="true"
    >
      <img
        src={`https://basemaps.cartocdn.com/rastertiles/voyager/${z}/${xT}/${yT}.png`}
        alt=""
        loading="lazy"
        className="absolute max-w-none"
        style={{ width: 256, height: 256, left: `calc(50% - ${px}px)`, top: H / 2 - py }}
      />
      <span
        className="absolute rounded-full border-2 border-sky-500/70 bg-sky-400/20"
        style={{ width: rPx * 2, height: rPx * 2, left: `calc(50% - ${rPx}px)`, top: H / 2 - rPx }}
      />
      <span
        className="absolute w-2.5 h-2.5 rounded-full bg-sky-600 border-2 border-white shadow"
        style={{ left: "calc(50% - 5px)", top: H / 2 - 5 }}
      />
    </div>
  );
}
